import { createClient } from '@supabase/supabase-js'
import { getAppImportMetaEnv } from './env.js'

const env = getAppImportMetaEnv()

const supabaseUrl = String(env.VITE_SUPABASE_URL ?? 'https://placeholder.supabase.co')
const supabaseAnonKey = String(env.VITE_SUPABASE_ANON_KEY ?? 'placeholder-anon-key')

if (!env.VITE_SUPABASE_URL || !env.VITE_SUPABASE_ANON_KEY) {
  console.warn('[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
